import React, { useState, useContext, useEffect } from 'react';
import axios from 'axios';
import ReactModal from 'react-modal';
import SglContext from '../SglContext';
import './platformFeeSetup.css';
import ManageCards from '../common/ManageCards';
import { useNavigate } from 'react-router-dom';
import { LoadingSpinner } from './teamManagement/utilities';


const PlatformFeeSetup = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [selectedCard, setSelectedCard] = useState(null);
  const [agreedToTerms, setAgreedToTerms] = useState(false);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // Credit Card Modal States
  const [isAddCardModalOpen, setIsAddCardModalOpen] = useState(false);
  const [check_card_email_phone_info, set_check_card_email_phone_info] = useState(false);
  const [check_address_info, set_check_address_info] = useState(false);
  

  // Terms of service Agreement States
  const [tosAgreement, setTosAgreement] = useState(null);
  const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);
  const [isSigningAgreement, setIsSigningAgreement] = useState(false);

  const [initialCheckComplete, setInitialCheckComplete] = useState(false);
  const [settingPaymentMethod, setSettingPaymentMethod] = useState(false);
  const [loadingAgreements, setLoadingAgreements] = useState(false);
  const [previousPaymentMethodIds, setPreviousPaymentMethodIds] = useState([]);
  const navigate = useNavigate();

  // Error msg state
  const [paymentMethodError, setPaymentMethodError] = useState('');
  
  const Sgl = useContext(SglContext);
  const sgl_webservice_iphone = Sgl.sglApiUrl+'/iphonev2/addentryv2/';

  const checkUserStatus = async (updateStep) => {
    let _hasPaymentMethod = Sgl?.pendingUserOnboardAction?.defaultPaymentMethod ? true : false
    let _hasSignedAgreement = Sgl?.pendingUserOnboardAction?.hasSignedTOS
    let _defaultPaymentMethod = paymentMethods.find((data) => data.sgl_id == Sgl?.pendingUserOnboardAction?.defaultPaymentMethod?.fingerprint_id)

    setSelectedCard(_defaultPaymentMethod?.sgl_id ?? null)

    if(updateStep){
      if (_hasPaymentMethod && !_hasSignedAgreement) {
        setCurrentStep(3); // Go to Terms screen
      } else if (!_hasPaymentMethod && _hasSignedAgreement) {
        setCurrentStep(2); // Go to Payment method screen
      } else if (!_hasPaymentMethod && !_hasSignedAgreement) {
        setCurrentStep(1); // Start from beginning
      } else {
        setCurrentStep(4); // Both complete go to success
      }

      setInitialCheckComplete(true);
    }
  }

  // Fetch payment methods from API

  const getOnboardingData = async () => {
    if (
      !Sgl?.pendingUserOnboardAction?.hasPendingAction ||
      (Sgl?.pendingUserOnboardAction?.defaultPaymentMethod &&
        Sgl?.pendingUserOnboardAction?.hasSignedTOS)
    ) {
      navigate('/');
      return; // prevent further execution
    }

    try {

      await Promise.all([
        checkUserStatus(true)
      ]);

    } catch (error) {
      console.error('Error fetching onboarding data:', error);
    } finally {
    }
  };

  useEffect(() => {
    getOnboardingData()
  }, [Sgl.current_user.sgl_id]);

  useEffect(() => {
    if (paymentMethods.length === 0) return;
    
    // only set selectedCard if it's currently null (initial load)
    if (selectedCard === null && Sgl?.pendingUserOnboardAction?.defaultPaymentMethod) {
      let _defaultPaymentMethod = paymentMethods.find(
        (data) => data.sgl_id == Sgl?.pendingUserOnboardAction?.defaultPaymentMethod?.fingerprint_id
      );
      if (_defaultPaymentMethod) {
        setSelectedCard(_defaultPaymentMethod.sgl_id);
      }
    }
  }, [paymentMethods])

  useEffect(() => {
    if(currentStep == 1 && initialCheckComplete && Sgl.current_user.sgl_id){
      createWelcomeScreenActionStep()
    }
    
    if(currentStep == 2){
      fetchPaymentMethods(true, true)
      let requiredAction = Sgl?.pendingUserOnboardAction?.pendingActions?.find((data) => data.Action.agreement_id == 0)
      if(!Sgl?.pendingUserOnboardAction?.defaultPaymentMethod && requiredAction?.sgl_id){
        axios.get(`${Sgl.nestApiUrl}/milestone-actions/updateRequiredActionStatus`,{
            params : {
              action_id: requiredAction?.sgl_id,
              status: 'In Progress'
            }
        })
      }
    }
    
    if(currentStep == 3.5){
      fetchTermsOfService()
      let requiredAction = Sgl?.pendingUserOnboardAction?.pendingActions?.find((data) => data.Action.agreement_id > 0)
      if(!Sgl?.pendingUserOnboardAction?.hasSignedTOS && requiredAction?.sgl_id){
        axios.get(`${Sgl.nestApiUrl}/milestone-actions/updateRequiredActionStatus`,{
            params : {
              action_id: requiredAction?.sgl_id,
              status: 'In Progress'
            }
        })
      }
    }
  
  }, [currentStep, initialCheckComplete, Sgl.current_user.sgl_id])

  useEffect(() => {
    if(isTermsModalOpen){
      createTosAgreementOpenActionStep()
    }
  }, [isTermsModalOpen])

  // Auto-select card if only one exists or if a new one was added
  useEffect(() => {
    // Skip if loading or no payment methods
    if (loading || paymentMethods.length === 0) return;
    
    // If only 1 card exists and nothing is selected, select it
    if (paymentMethods.length === 1 && !selectedCard) {
      setSelectedCard(paymentMethods[0].sgl_id);
      setPaymentMethodError('');
    }
  }, [paymentMethods, loading, selectedCard]);

  // Auto-select card if only one exists or if a new one was added
  useEffect(() => {
    // Skip if loading or no payment methods
    if (loading || paymentMethods.length === 0) return;
    
    // If only 1 card exists and nothing is selected, select it
    if (paymentMethods.length === 1 && !selectedCard) {
      setSelectedCard(paymentMethods[0].sgl_id);
      setPaymentMethodError('');
    }
  }, [paymentMethods, loading, selectedCard]);

  // Send confirmation email when reaching step 4
  useEffect(() => {
    if (currentStep === 4 && initialCheckComplete) {
      sendConfirmationEmail();
    }
  }, [currentStep, initialCheckComplete]);

  // Pay Method Functions: START >>>
  const fetchPaymentMethods = async (updateActionStep, reLoadPaymentMethod=true) => {
    
    let paymentMethodLoaded = false
    let errorMessage = ''

    let actionStep = updateActionStep && !Sgl?.pendingUserOnboardAction?.defaultPaymentMethod ? await axios.post(`${Sgl.nestApiUrl}/billing/createActionStepData`, {
        action: 'Pay Method',
        data: {},
        loginId: Sgl.current_user.sgl_id,
        companyId: Sgl.company_id,
        desc: 'Default Payment Method Screen'
    }) : null

    try {
      setLoading(true);
      if(reLoadPaymentMethod){
        const response = await axios.get(Sgl.sglApiUrl + '/iphonev2/addentryv2/GetPaymentMethods', {
          params: {
            company_id: Sgl.company_id,
          }
        });

        // Check if this is after adding a new card
        if (previousPaymentMethodIds.length > 0) {
          const newCards = response.data.payment_methods.filter(
            pm => !previousPaymentMethodIds.includes(pm.sgl_id)
          );
                  
          if (newCards.length > 0) {
            const newCardId = newCards[0].sgl_id;
                      
            // Set all states
            setSelectedCard(newCardId);
            setPaymentMethodError('');
            setPreviousPaymentMethodIds([]); // Reset tracking
            
            paymentMethodLoaded = true;
            setLoading(false);
            
            // Exit early after successful auto-select
            if(actionStep?.data?.sgl_id > 0){
              axios.post(`${Sgl.nestApiUrl}/billing/completeActionStepData`, {
                actionStepId: actionStep?.data?.sgl_id,
                status: 'Complete',
                desc: 'Payment methods loaded and new card auto-selected',
                error: ''
              });
            }
          }
          
          // Reset tracking even if no new cards found
          setPreviousPaymentMethodIds([]);
        }
        
        setPaymentMethods(response.data.payment_methods || []); 
        set_check_address_info(response.data.check_address_info);
        paymentMethodLoaded = true 
      }else{
        paymentMethodLoaded = true
      }
    } catch (error) {
      errorMessage = error;
      setPreviousPaymentMethodIds([]); 
    }

    setLoading(false);

    if(actionStep?.data?.sgl_id > 0){
      let data = {
        actionStepId: actionStep?.data?.sgl_id,
        status: paymentMethodLoaded ? 'Complete' : 'Failure',
        desc: paymentMethodLoaded
        ? 'Payment Methods loaded successfully'
        : 'Failed to load payment methods.',
        error: paymentMethodLoaded ? '' : errorMessage
      }

      axios.post(`${Sgl.nestApiUrl}/billing/completeActionStepData`, data)
    }
  };

  const handleContinueFromPayment = () => {
    if(
      !Sgl?.pendingUserOnboardAction?.hasPendingAction ||
      (
        Sgl?.pendingUserOnboardAction?.defaultPaymentMethod && 
        Sgl?.pendingUserOnboardAction?.defaultPaymentMethod?.fingerprint_id == selectedCard
      )
    ){
      if(Sgl?.pendingUserOnboardAction?.hasSignedTOS){
        setCurrentStep(4);
      }else{
        setCurrentStep(3);
      }
      
      return
    }

    // Update the default payment method
    const selectedPaymentMethod = paymentMethods.find((data) => data.sgl_id == selectedCard);
    setDefaultPaymentMethodForUser(selectedPaymentMethod)
  };

  const setDefaultPaymentMethodForUser = async(selectedPaymentMethod) => {
  
    let _error = ''
    if(!selectedPaymentMethod){
        _error = 'Please select a payment method.'
    }

    if(_error != ''){
        setPaymentMethodError(_error)
        return
    }

    setSettingPaymentMethod(true)

    let authActionStep = !Sgl?.pendingUserOnboardAction?.defaultPaymentMethod ? await axios.post(`${Sgl.nestApiUrl}/billing/createActionStepData`, {
        action: 'Pay Method',
        data: {selectedPaymentMethod},
        loginId: Sgl.current_user.sgl_id,
        companyId: Sgl.company_id,
        desc: 'Authenticating default payment method'
    }) : null

    try{
        // check if valid card is selected as default payment method
        let result = await axios.get(sgl_webservice_iphone+'PreAuthorizeCreditCard',{
            params : {
                secured_payment_method_fingerprint_id : selectedPaymentMethod.sgl_id,
                company_id: -1
            }
        })

        if(result?.data != ''){
            setPaymentMethodError(result.data)
            if(authActionStep?.data?.sgl_id > 0){
                axios.post(`${Sgl.nestApiUrl}/billing/completeActionStepData`, {
                    actionStepId: authActionStep?.data?.sgl_id,
                    status: 'Failure',
                    desc: `Payment method ${selectedPaymentMethod.name_on_card} xxxx-${selectedPaymentMethod.card_lastfour} authentication failed`,
                    error: result.data
                })
            }

            setSettingPaymentMethod(false)
            return
        }

        console.error("validating payment method message:", result);
    } catch (err) {
        console.error("Error validating payment method:", err);
        setPaymentMethodError(err.message)
        if(authActionStep?.data?.sgl_id > 0){
            axios.post(`${Sgl.nestApiUrl}/billing/completeActionStepData`, {
                actionStepId: authActionStep?.data?.sgl_id,
                status: 'Failure',
                desc: `Payment method ${selectedPaymentMethod.name_on_card} xxxx-${selectedPaymentMethod.card_lastfour} authentication failed`,
                error: err.message
            })
        }
        setSettingPaymentMethod(false)
        return
    }

    if(authActionStep?.data?.sgl_id > 0){
        axios.post(`${Sgl.nestApiUrl}/billing/completeActionStepData`, {
            actionStepId: authActionStep?.data?.sgl_id,
            status: 'Complete',
            desc: `Payment method ${selectedPaymentMethod.name_on_card} xxxx-${selectedPaymentMethod.card_lastfour} authenticated successfully`,
            error: ''
        })
    }

    let respActionStep = !Sgl?.pendingUserOnboardAction?.defaultPaymentMethod ? await axios.post(`${Sgl.nestApiUrl}/billing/createActionStepData`, {
        action: 'Pay Method',
        data: {selectedPaymentMethod},
        loginId: Sgl.current_user.sgl_id,
        companyId: Sgl.company_id,
        desc: 'Setting default payment method'
    }) : null
  
    setPaymentMethodError('')
    await axios.post(`${Sgl.nestApiUrl}/billing/updateDefaultCreditCard`, {
        user_id: Sgl.current_user.sgl_id,
        payment_method_id: selectedPaymentMethod.sgl_id,
        company_id: Sgl.company_id
    }).then(async (res) => {

        if(res.data.success){
            Sgl.setHasDefaultPaymentMethod(true)

            if(respActionStep?.data?.sgl_id > 0){
                axios.post(`${Sgl.nestApiUrl}/billing/completeActionStepData`, {
                    actionStepId: respActionStep?.data?.sgl_id,
                    status: 'Complete',
                    desc: `Default payment method ${selectedPaymentMethod.name_on_card} xxxx-${selectedPaymentMethod.card_lastfour} set successfully`,
                    error: ''
                })
            }
            
            if(Sgl?.pendingUserOnboardAction?.hasSignedTOS){
              setCurrentStep(4);
            }else{
              setCurrentStep(3);
            }
            await Sgl.getPendingUserActions()
        }else{
            setPaymentMethodError(res.data.error)
            if(respActionStep?.data?.sgl_id > 0){
                axios.post(`${Sgl.nestApiUrl}/billing/completeActionStepData`, {
                    actionStepId: respActionStep?.data?.sgl_id,
                    status: 'Failure',
                    desc: `Failed to set default payment method ${selectedPaymentMethod.name_on_card} xxxx-${selectedPaymentMethod.card_lastfour}.`,
                    error: res.data.error
                })
            }
        }
    });

    setSettingPaymentMethod(false)
    return
    
  }
  // Pay Method Functions: END <<<

  // TOS Functions: START >>>

  // get the TOS agreement 
  const fetchTermsOfService = async () => {
  
    let agreementLoaded = false
    let errorMessage = ''
    setLoadingAgreements(true)

    // create action step
    let actionStepRes = await axios.post(`${Sgl.nestApiUrl}/billing/createActionStepData`, {
      action: 'Terms of Service',
      data: {},
      loginId: Sgl.current_user.sgl_id,
      companyId: Sgl.company_id,
      desc: 'Terms of Service Screen'
    })

    try {
      const response = await axios.get(
        `${Sgl.nestApiUrl}/billing/getTermsOfServiceAgreement`,
        {
          params: {
            company_id: Sgl.company_id,
            user_id: Sgl.current_user?.sgl_id
          }
        }
      );
      
      if (response.data.success) {
        setTosAgreement(response.data.agreement);
        agreementLoaded = true
      }else{
        errorMessage = response.data.error
      }
    } catch (error) {
      console.error('Error fetching Terms of Service:', error);
      errorMessage = error
    }

    if(actionStepRes?.data?.sgl_id > 0){
      let data = {
        actionStepId: actionStepRes?.data?.sgl_id,
        status: agreementLoaded ? 'Complete' : 'Failure',
        desc: agreementLoaded ? 'Terms of Service agreement loaded successfully' : `Error fetching Terms of Service.`,
        error: agreementLoaded ? '' : errorMessage
      }

      axios.post(`${Sgl.nestApiUrl}/billing/completeActionStepData`, data)
    }

    setLoadingAgreements(false)
  };

  // sign TOS agreement
  const signAgreement = async() => {
       
    if (!agreedToTerms || isSigningAgreement) return;
    if (!tosAgreement) {
      alert('Terms of Service not loaded. Please try again.');
      return;
    }

    let errorMessage = ''
    let agreementSigned = false
    setIsSigningAgreement(true);

    let respActionStep = await axios.post(`${Sgl.nestApiUrl}/billing/createActionStepData`, {
        action: 'Terms of Service',
        data: tosAgreement,
        loginId: Sgl.current_user.sgl_id,
        companyId: Sgl.company_id,
        desc: 'Signing Terms of Service agreement'
    })

    try{
      
      await axios.post(`${Sgl.nestApiUrl}/billing/signAgreement`, {
          application_id: tosAgreement.application_id,
          agreement_id: tosAgreement.id,
          user_id: Sgl.current_user?.sgl_id,
          company_id: Sgl.company_id
      }).then(async(res) => {

          if(res.data.success){
            Sgl.refreshPendingAgreementsCount()
            agreementSigned = true
            setCurrentStep(4);
            await Sgl.getPendingUserActions()
          }else{
            errorMessage = res.data.error
          }
      });
      setIsSigningAgreement(false);
    } catch (error) {
      console.error('Error fetching Terms of Service:', error);
      errorMessage = error
    }

    if(respActionStep?.data?.sgl_id > 0){
      let data = {
        actionStepId: respActionStep?.data?.sgl_id,
        status: agreementSigned ? 'Complete' : 'Failure',
        desc: agreementSigned ? 'Terms of Service agreement signed successfully' : 'Failed to sign Terms of Service agreement',
        error: agreementSigned ? '' : errorMessage
      }

      axios.post(`${Sgl.nestApiUrl}/billing/completeActionStepData`, data)
    }
  }

    const sendConfirmationEmail = async () => {
      try {
        // Get selected card details
        const selectedPaymentMethod = paymentMethods.find(
          pm => pm.sgl_id === selectedCard
        );
        
        if (!selectedPaymentMethod) {
          console.error('Selected payment method not found');
          return;
        }
        const emailData = {
          user_id: Sgl.current_user?.sgl_id,
          email_data: {
            user_name: Sgl.current_user?.full_name || `${Sgl.current_user?.first || ''} ${Sgl.current_user?.last_name || ''}`.trim(),
            user_email: Sgl.current_user?.email_address,
            company_name: Sgl.company_name,
            payment_method_type: selectedPaymentMethod.type,
            payment_method_last4: selectedPaymentMethod.card_lastfour,
            platform_fee: '$10',
            effective_date: 'January 1, 2026',
            agreement_name: tosAgreement?.title || 'Platform Fee Terms of Service'
          }
        };

        await axios.post( `${Sgl.nestApiUrl}/billing/sendOnboardingConfirmationEmail`, emailData );
        
        console.log('Confirmation email sent successfully');
      } catch (error) {
        console.error('Error sending confirmation email:', error);    }
    };

  // TOS Functions: END <<<

  const renderProgressBar = () => (
    <div className="pfs-progress-bar">
      {[
        { num: 1, label: 'Welcome' },
        { num: 2, label: 'Payment' },
        { num: 3, label: 'Review' },
        { num: 4, label: 'Complete' }
      ].map(step => (
        <div key={step.num} className="pfs-progress-step">
          <div className={`pfs-progress-circle ${currentStep > step.num ? 'completed' : currentStep === step.num ? 'active' : ''}`}>
            {currentStep > step.num ? '✓' : step.num}
          </div>
          <span className={`pfs-progress-label ${currentStep === step.num ? 'active' : ''}`}>
            {step.label}
          </span>
        </div>
      ))}
    </div>
  );

  const createWelcomeScreenActionStep = async() => {
  
    // Add action step for welcome sreen
    let paymentMethodActionStep = await axios.post(`${Sgl.nestApiUrl}/billing/createActionStepData`, {
      action: 'Terms of Service',
      data: {},
      loginId: Sgl.current_user.sgl_id,
      companyId: Sgl.company_id,
      desc: 'Onboarding Welcome Screen'
    });

    if (paymentMethodActionStep?.data?.sgl_id > 0) {
      let data = {
        actionStepId: paymentMethodActionStep.data.sgl_id,
        status: 'Complete',
        desc: 'User redirected to the onboarding welcome screen',
        error: ''
      };

      axios.post(`${Sgl.nestApiUrl}/billing/completeActionStepData`, data);
    }

    let tosActionStep = await axios.post(`${Sgl.nestApiUrl}/billing/createActionStepData`, {
        action: 'Pay Method',
        data: {},
        loginId: Sgl.current_user.sgl_id,
        companyId: Sgl.company_id,
        desc: 'Onboarding Welcome Screen'
    })

    if(tosActionStep?.data?.sgl_id > 0){
      let data = {
        actionStepId: tosActionStep?.data?.sgl_id,
        status: 'Complete',
        desc: 'User redirected to the onboarding welcome screen',
        error: ''
      }

      axios.post(`${Sgl.nestApiUrl}/billing/completeActionStepData`, data)
    }
  }

  const createTosAgreementOpenActionStep = async() => {
    // Add action step for welcome sreen
    let paymentMethodActionStep = await axios.post(`${Sgl.nestApiUrl}/billing/createActionStepData`, {
      action: 'Terms of Service',
      data: tosAgreement,
      loginId: Sgl.current_user.sgl_id,
      companyId: Sgl.company_id,
      desc: 'Terms of Service Dialog Opened'
    });

    if (paymentMethodActionStep?.data?.sgl_id > 0) {
      let data = {
        actionStepId: paymentMethodActionStep.data.sgl_id,
        status: 'Complete',
        desc: 'Terms of Service displayed successfully',
        error: ''
      };

      axios.post(`${Sgl.nestApiUrl}/billing/completeActionStepData`, data);
    }
  }

  const renderWelcomeScreen = () => (
      <div className="pfs-content">
      <h2 className="pfs-section-title">Important Update to ShowGrounds</h2>
      <p className="pfs-intro-text">
          Starting January 1, 2026, we're introducing a platform fee to help us continue providing you with the best equestrian event management experience.
      </p>
      
      <div className="pfs-info-box">
          <h3 className="pfs-info-box-title">What's changing?</h3>
          
          <ul className="pfs-info-list">
          <li>A $10 platform fee per entry</li>
          <li>Convenient daily billing (one charge for all your entries)</li>
          <li>Full refunds for scratches before show day</li>
          <li>New features are coming, designed specifically for exhibitors.</li>
          </ul>
      </div>
      
      <p className="pfs-note">
          We'll walk you through everything in just 3 quick steps. The whole process takes less than 2 minutes.
      </p>
      
      <div className="pfs-actions">
          <button onClick={() => setCurrentStep(2)} className="pfs-btn-primary-custom">
          Get Started
          </button>
      </div>
      </div>
  );

  const renderPaymentScreen = () => (
    <div className="pfs-content">
      <h2 className="pfs-section-title">Select Your Payment Method</h2>
      
      <p className="pfs-intro-text">
        Choose which payment method to use for your ShowGrounds platform fees. We'll batch all your daily entries together for convenience.
      </p>
      
      <div className="pfs-example-box">
        <strong>Example:</strong> If you enter 5 horses on Monday, you'll receive one invoice with the five charges listed and a single $50 charge to pay that invoice.
      </div>
      
      <h3 className="pfs-subsection-title">Your Payment Methods</h3>
      
      {loading ? (
        <div className="pfs-loading">Loading payment methods...</div>
      ) : paymentMethods.length > 0 ? (
        <div className="pfs-payment-section">
          <div className="pfs-payment-table-container">
            <table className="pfs-payment-table contains-border">
              <thead>
                <tr className="pfs-payment-table-header">
                  <th className="pfs-display-desktop"></th>
                  <th className="pfs-display-desktop">CARD NUMBER</th>
                  <th className="pfs-display-desktop">NAME ON CARD</th>
                  <th className="pfs-display-desktop">TYPE</th>
                  <th className="pfs-display-desktop">EXPIRATION</th>
                </tr>
              </thead>
              <tbody>
                {paymentMethods.map((card, idx) => (
                  <tr key={idx} className="pfs-payment-table-row" 
                  onClick={() => {
                    setSelectedCard(card.sgl_id);
                    setPaymentMethodError('');
                  }}>
                    <td className={`pfs-display-mobile pfs-payment-mobile-card ${selectedCard === card.sgl_id ? 'selected' : ''}`}>
                      <div className="pfs-payment-card-content">
                        <div className="pfs-payment-row">
                          <span className="pfs-payment-label">Card No.:</span>
                          <span className="pfs-payment-value">xxxx-{card.card_lastfour}</span>
                        </div>
                        <div className="pfs-payment-row">
                          <span className="pfs-payment-label">Name on Card:</span>
                          <span className="pfs-payment-value">{card.name_on_card}</span>
                        </div>
                        <div className="pfs-payment-row">
                          <span className="pfs-payment-label">Type:</span>
                          <span className="pfs-payment-value">{card.type}</span>
                        </div>
                        <div className="pfs-payment-row">
                          <span className="pfs-payment-label">Expiration:</span>
                          <span className="pfs-payment-value">{card.card_exp}</span>
                        </div>
                      </div>
                    </td>
                    
                    <td className="pfs-display-desktop">
                      <input
                        type="radio"
                        name="card"
                        checked={selectedCard === card.sgl_id}
                        onChange={() => {
                          setSelectedCard(card.sgl_id);
                          setPaymentMethodError(''); 
                        }}
                        className="pfs-radio-input"
                      />
                    </td>
                    <td className="pfs-display-desktop">
                      <div className="pfs-payment-card-info">
                        <div className="pfs-payment-card-number">xxxx-{card.card_lastfour}</div>
                      </div>
                    </td>
                    <td className="pfs-display-desktop">
                      <div className="pfs-payment-cardholder-name">{card.name_on_card}</div>
                    </td>
                    <td className="pfs-display-desktop">
                      <span className="pfs-payment-card-type">{card.type}</span>
                    </td>
                    <td className="pfs-display-desktop">
                      <span className="pfs-payment-expiry">{card.card_exp}</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        <div className="pfs-payment-empty-state">
          <div className="pfs-empty-state-message">You have no credit cards with your account.</div>
        </div>
      )}

      {/* Error msg */}
      {paymentMethodError && (
        <div className="pfs-payment-error-message">
          {paymentMethodError}
        </div>
      )}
      
      <button className="pfs-btn-add-card" 
      onClick={() => {
        setPreviousPaymentMethodIds(paymentMethods.map(pm => pm.sgl_id));
        setIsAddCardModalOpen(true);
      }}>
        Add Payment Method
      </button>
      
      <p className="pfs-note-small">
        <strong>Note:</strong> This selection only affects platform fees. Your entry fee payment methods remain unchanged.
      </p>
      
      <div className="pfs-actions pfs-actions-mobile-row">
        <button onClick={() => setCurrentStep(1)} className="pfs-btn-secondary-custom">
          Back
        </button>
        <button onClick={() => handleContinueFromPayment()} className="pfs-btn-primary-custom" disabled={settingPaymentMethod}>
          {
            settingPaymentMethod ? 'Setting Default Payment Method...' : 'Continue'
          }
        </button>
      </div>
    </div>
  );

  const renderReviewScreen = () => (
    <div className="pfs-content">
      <h2 className="pfs-section-title">Here's How It Works</h2>
      
      <div className="pfs-price-display">
        <div className="pfs-price-amount">$10</div>
        <p className="pfs-price-subtitle">per entry starting January 1, 2026</p>
      </div>
      
      <div className="pfs-features-list">
        {[
          {
            title: 'Daily Batch Billing',
            desc: 'All your entries for the day are charged together the next morning'
          },
          {
            title: 'Separate Transactions',
            desc: 'Entry fees go to the show, platform fees come to ShowGrounds - you\'ll see both on your statement'
          },
          {
            title: 'Scratch Policy',
            desc: 'Full refund if you scratch before the first day of the show'
          },
          {
            title: 'Office Entries',
            desc: 'If you pay by check at the show, the $10 fee will be added to your show bill'
          }
        ].map((item, idx) => (
          <div key={idx} className="pfs-feature-item">
            <div className="pfs-feature-icon">✓</div>
            <div className="pfs-feature-content">
              <h3 className="pfs-feature-title">{item.title}</h3>
              <p className="pfs-feature-desc">{item.desc}</p>
            </div>
          </div>
        ))}
      </div>
      <p className='pfs-note-small pfs-review-terms-note'>
        <strong>Note: </strong>Click "Review & Accept Terms" below to view full terms and conditions.
      </p>
      
      <div className="pfs-actions pfs-actions-mobile-row">
        <button onClick={() => setCurrentStep(2)} className="pfs-btn-secondary-custom">
          Back
        </button>
        <button onClick={() => setCurrentStep(3.5)} className="pfs-btn-primary-custom">
          Review & Accept Terms
        </button>
      </div>
    </div>
  );

  const renderTermsScreen = () => (
    <div className="pfs-content">
      <h2 className="pfs-section-title">
        {tosAgreement?.title || 'Terms of Service'}
      </h2>

      {
        loadingAgreements ? 
        <div className="pfs-loading">Loading Terms of Service...</div>
        :
        <>
         <div className="pfs-terms-content-box">
          {tosAgreement?.description && (
            <div 
              className="pfs-terms-item"
              dangerouslySetInnerHTML={{ __html: tosAgreement.description }}
            />
          )}
          
          <div className="pfs-terms-read-full">
            <a 
              href="#" 
              className="pfs-terms-link"
              onClick={(e) => {
                e.preventDefault();
                setIsTermsModalOpen(true);
              }}
            >
              Read complete Terms of Service
            </a>
          </div>
        </div>
        
        <div className="pfs-terms-checkbox-container">
          <label className="pfs-terms-checkbox-label">
            <input
              type="checkbox"
              checked={agreedToTerms}
              onChange={(e) => setAgreedToTerms(e.target.checked)}
              className="pfs-terms-checkbox"
            />
            <span>
              I have read and agree to the {tosAgreement?.title || 'Terms of Service'}, 
              including the $10 per entry platform fee starting January 1, 2026.
            </span>
          </label>
        </div>
        </>
      }
      
      <div className="pfs-actions pfs-actions-mobile-row">
        <button onClick={() => setCurrentStep(3)} className="pfs-btn-secondary-custom">
          Back
        </button>
        <button 
          onClick={signAgreement} 
          disabled={!agreedToTerms || isSigningAgreement || loadingAgreements}
          className="pfs-btn-primary-custom"
        >
          {isSigningAgreement ? 'Signing Agreement...' : 'I Agree & Complete Setup'}
        </button>
      </div>
    </div>
  );

  const renderCompleteScreen = () => (
    <div className="pfs-complete-screen pfs-content">
      <div className="pfs-success-icon">✓</div>
      
      <h2 className="pfs-section-title">You're All Set!</h2>
      
      <p className="pfs-intro-text">
        Thank you for setting up your payment method and accepting the new terms.
      </p>
      
      <p className="pfs-intro-text">
        You can now continue entering shows as usual. Remember, the platform fee starts January 1, 2026.
      </p>
      
      <div className="pfs-info-box">
        <h3 className="pfs-info-box-title">Quick Reminder</h3>
        <p className="pfs-info-box-text">
          We'll send you an email confirmation with everything we covered today.
        </p>
      </div>
      
      <div className="pfs-actions pfs-actions-mobile-row">
        <button 
          onClick={() => window.location.href = '/'}
          className="pfs-btn-primary-custom"
        >
          Continue to ShowGrounds
        </button>
      </div>
    </div>
  );

  return (
    // loadingOnBoardingData ? <LoadingSpinner /> :
    <div className="pfs-wrapper">
      <div className="pfs-container">
        {currentStep !== 1 && renderProgressBar()}
        
        {currentStep === 1 && renderWelcomeScreen()}
        {currentStep === 2 && renderPaymentScreen()}
        {currentStep === 3 && renderReviewScreen()}
        {currentStep === 3.5 && renderTermsScreen()}
        {currentStep === 4 && renderCompleteScreen()}
      </div>

      {/* Add Credit Card Modal */}
      {isAddCardModalOpen && (
        <ManageCards
          payment_methods={paymentMethods}
          defaultPaymentMethod={Sgl?.pendingUserOnboardAction?.defaultPaymentMethod}
          check_card_email_phone_info={check_card_email_phone_info}
          check_address_info={check_address_info}
          is_open_manage_card_modal={false}
          is_open_add_card_modal={isAddCardModalOpen}
          closeManageCardModal={() => {
            setIsAddCardModalOpen(false);
          }}
          getPaymentMethods={() => fetchPaymentMethods(false)}
          calledFor={'Platform Fee Setup'}
          team_id={0}
        />
      )}

      {/* Terms of Service Content Modal */}
      <ReactModal
        isOpen={isTermsModalOpen}
        onRequestClose={() => setIsTermsModalOpen(false)}
        className="add-credit-card-modal-content terms-modal-content"
        overlayClassName="add-credit-card-modal-overlay"
        ariaHideApp={false}
      >
        <div className="add-credit-card-modal-container">
          <div className="add-credit-card-modal-header">
            <h2 className="add-credit-card-modal-title">
              {tosAgreement?.title || 'Terms of Service'}
            </h2>
            <button 
              onClick={() => setIsTermsModalOpen(false)} 
              className="add-credit-card-modal-close"
            >
              ✕
            </button>
          </div>

          <div className="add-credit-card-modal-body">
            {tosAgreement?.content ? (
              <div 
                className="pfs-terms-full-content"
                dangerouslySetInnerHTML={{ __html: tosAgreement.content }}
              />
            ) : (
              <p>Loading terms content...</p>
            )}
          </div>

          <div className="add-credit-card-modal-footer">
            <button 
              className="terms-modal-footer-close-btn" 
              onClick={() => setIsTermsModalOpen(false)}
            >
              Close
            </button>
          </div>
        </div>
      </ReactModal>
    </div>
  );
};

export default PlatformFeeSetup;